import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { IPointAward } from 'components/awards/models';
import { useTokenizedString } from '../useTokenizedString';

const PREFIX = 'AdHoc';

const classes = {
    title: `${PREFIX}title`,
    subtitle: `${PREFIX}subtitle`,
    description: `${PREFIX}description`
};

const StyledBox = styled(Box)(({ theme }) => ({
    width: '100%',
    [`& .${classes.title}`]: {
        fontSize: '2em',
        fontWeight: theme.typography.fontWeightBold
    },

    [`& .${classes.subtitle}`]: {
        fontSize: '1.25em',
        fontWeight: theme.typography.fontWeightBold
    },

    [`& .${classes.description}`]: {
        fontSize: '1em'
    }
}));

interface IProps {
    award: IPointAward;
}

export const AdHoc: React.FC<IProps> = ({ award }) => {
    const { renderTokenizedString } = useTokenizedString(award);

    return (
        <StyledBox>
            {award.visualisation.titleText && (
                <Typography display="block" className={classes.title}>
                    {award.visualisation.titleText}
                </Typography>
            )}
            {award.visualisation.subtitleText && (
                <Typography display="block" className={classes.subtitle}>
                    {renderTokenizedString(award.visualisation.subtitleText)}
                </Typography>
            )}
            {award.visualisation.subtitleTwoText && (
                <Typography display="block" className={classes.description}>
                    {renderTokenizedString(award.visualisation.subtitleTwoText)}
                </Typography>
            )}
        </StyledBox>
    );
};
